import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";

import CloneICON from "../../../assets/images/clone.svg";
import TimerModal from "./TimerModal";

let _second = 1000;
let _minute = _second * 60;
let _hour = _minute * 60;
let _day = _hour * 24;

const Timer = (props) => {
  const [timerEditDisplay, setTimerEditDisplay] = useState(false);
  const [days, setDays] = useState("00");
  const [hours, setHours] = useState("00");
  const [minutes, setMinutes] = useState("00");
  const [seconds, setSeconds] = useState("00");
  const [timerMarginUnit, setTimerMarginUnit] = useState("px")

  useEffect(() => {
    if (props.timerMarginUnit) setTimerMarginUnit(props.timerMarginUnit)
  }, [props])


  const getTimerVal = () => {
    var now = new Date();
    var distance = new Date(props.date) - now;
    if (distance < 0) {
      setDays("00");
      setHours("00");
      setMinutes("00");
      setSeconds("00");
      return;
    } else {
      setDays(Math.floor(distance / _day));
      setHours(Math.floor((distance % _day) / _hour));
      setMinutes(Math.floor((distance % _hour) / _minute));
      setSeconds(Math.floor((distance % _minute) / _second));
    }
  };


  useEffect(() => {
    const timer = setInterval(() => {
      getTimerVal();
    }, 1000);
    return () => clearInterval(timer);
  }, [props.date]);


  return (
    <div className="timer-wrapper">
      <div className="actionControl">
        <span className="image-setting" onClick={() => setTimerEditDisplay(true)}>
          Timer Settings
        </span>
        <button className="clone-item" onClick={() => { props.cloneElement(props.element.id) }}>
          <img src={CloneICON} />
        </button>
        <span className="delete-item" onClick={() => { props.deleteElement(props.element.id) }}>
          <i className="far fa-trash-alt" />
        </span>
      </div>
      <div className="timerMain">
        <ul
          className={`${props.patternStyle} ${props.mobileView & (props.size == "large") ? "medium" : props.size}`}
          style={{
            float: props.float,
            fontFamily: props.fontFamily,
            marginTop: props.marginTop + timerMarginUnit,
            marginRight: props.marginRight + timerMarginUnit,
            marginBottom: props.marginBottom + timerMarginUnit,
            marginLeft: props.marginLeft + timerMarginUnit,
          }}
        >
          <li>
            <span>{days}</span>
            <p className="exclude-from-override-style"><FormattedMessage id="timer.days" defaultMessage={"days"} /></p>
          </li>
          <li>
            <span>{hours}</span>
            <p className="exclude-from-override-style"><FormattedMessage id="timer.hours" defaultMessage={"hours"} /></p>
          </li>
          <li>
            <span>{minutes}</span>
            <p className="exclude-from-override-style"><FormattedMessage id="timer.minutes" defaultMessage={"minutes"} /></p>
          </li>
          <li>
            <span>{seconds}</span>
            <p className="exclude-from-override-style"><FormattedMessage id="timer.seconds" defaultMessage={"seconds"} /></p>
          </li>
        </ul>
      </div>
      {
        timerEditDisplay && (
          <TimerModal
            mobileView={props.mobileView}
            ID={props.ID}
            size={props.size}
            float={props.float}
            date={new Date(props.date)}
            patternStyle={props.patternStyle}
            label={props.label}
            timerMarginUnit={props.timerMarginUnit}
            marginTop={props.marginTop}
            marginRight={props.marginRight}
            marginBottom={props.marginBottom}
            marginLeft={props.marginLeft}
            margin={props.margin}
            hideTimer={() => { setTimerEditDisplay(false) }}
          />
        )
      }
    </div>
  );
}
export default Timer;
